import { __assign } from "tslib";
import { formatDollars } from '../../../../utils/formatting';
var dasContentAdapter = function (props) {
    var _a, _b, _c, _d, _e;
    var deviation = props.deviation;
    var price = (_c = (_b = (_a = deviation.digitalAsset) === null || _a === void 0 ? void 0 : _a.asset) === null || _b === void 0 ? void 0 : _b.price) !== null && _c !== void 0 ? _c : '???';
    var dollarsCost = ((_e = (_d = deviation.digitalAsset) === null || _d === void 0 ? void 0 : _d.asset) === null || _e === void 0 ? void 0 : _e.dollarPrice) !== undefined
        ? formatDollars(deviation.digitalAsset.asset.dollarPrice)
        : '???';
    return __assign(__assign({}, props), { price: price, dollarsCost: dollarsCost, priceLabel: 'shop.thumb.points' });
};
export default dasContentAdapter;
//# sourceMappingURL=das.js.map